import { connect } from "vuex-connect";
// import log from 'loglevel';
import { ImageUploader } from "../../../components";

export default connect({
  stateToProps: {
    draftId: state => state.uploadContents.draftId,
    images: state => state.uploadContents.images,
    pageProgressionDirection: state =>
      state.uploadContents.pageProgressionDirection
  },
  gettersToProps: {
    getNotIncludeCoverDataImageCount:
      "uploadContents/getNotIncludeCoverDataImageCount"
  },
  mutationsToProps: {
    setIsBusy: "uploadContents/setIsImageBusy",
    pushImages: "uploadContents/pushImages",
    setUploadingImageCount: "uploadContents/setUploadingImageCount"
  },
  actionsToProps: {
    postDraftImage: (dispatch, value) => {
      return dispatch("uploadContents/postDraftImage", value);
    },
    sortImages: (dispatch, value) => {
      return dispatch("uploadContents/sortImages", value);
    },
    postDraftBlankImage: (dispatch, value) =>
      dispatch("uploadContents/postDraftBlankImage", value),
    postCoverImage: (dispatch, value) =>
      dispatch("uploadContents/postFrontCoverImage", value),
    setInitialStaticImageData: dispatch =>
      dispatch("uploadContents/setInitialStaticImageData"),
    putBlankArea: dispatch => dispatch("uploadContents/putBlankArea"),
    deleteBlankArea: dispatch => dispatch("uploadContents/deleteBlankArea")
  }
})(ImageUploader.name, ImageUploader);
